// extracted by mini-css-extract-plugin
export var colorTable = "tables-module--colorTable--2PT5V";
export var gray = "tables-module--gray--ozfAA";
export var green = "tables-module--green--Vd5sA";
export var orange = "tables-module--orange--3s8Rt";
export var purple = "tables-module--purple--2ztI3";